import { DRAG_BUTTON_CLASS_NAME } from '@ardoq/icons';
import {
  DragAndDropContextState,
  DragAndDropOrientation,
  Position,
} from './types';

export const arrayMove = <T>(
  array: T[],
  fromIndex: number,
  toIndex: number
): T[] => {
  const arrayCopy = [...array];
  arrayCopy.splice(toIndex, 0, arrayCopy.splice(fromIndex, 1)[0]);
  return arrayCopy;
};

export const isTargetDragHandleButton = (target: EventTarget) =>
  target instanceof Element &&
  target.closest(`.${DRAG_BUTTON_CLASS_NAME}`) !== null;

type DropTargetRect = Pick<DOMRect, 'left' | 'top' | 'width' | 'height'>;

export const getDropPosition = (
  rect: DropTargetRect,
  clientX: number,
  clientY: number,
  orientation: DragAndDropOrientation
): Position => {
  if (orientation === 'horizontal') {
    const middle = rect.left + rect.width / 2;
    return middle > clientX ? 'before' : 'after';
  }
  const middle = rect.top + rect.height / 2;
  return middle > clientY ? 'before' : 'after';
};

export const isNoOpDrop = (
  currentOrder: string[],
  { draggedCardId, draggedOverCardId, position }: DragAndDropContextState
): boolean => {
  if (!draggedCardId || !draggedOverCardId || !position) return true;
  if (draggedCardId === draggedOverCardId) return true;
  const draggedIndex = currentOrder.indexOf(draggedCardId);
  const overIndex = currentOrder.indexOf(draggedOverCardId);
  if (draggedIndex === -1 || overIndex === -1) return true;
  return (
    (position === 'after' && overIndex === draggedIndex - 1) ||
    (position === 'before' && overIndex === draggedIndex + 1)
  );
};
